import { ConfirmDialog } from '@/components/blocks/ConfirmDialog/ConfirmDialog';
import { WALLET_PHRASES, WALLET_REQUEST_PHRASES } from '@/consts/phrases/walletPhrases';
import { usePhrase } from '@/hooks';
import { walletService } from '@/services/api';
import { config } from '@/config';
import { mutate } from 'swr';
import { useState } from 'react';

const API_URL = config.api.url.wallet;

interface CancelTransactionModalProps {
    handleClose: () => void;
    isOpen: boolean;
    transactionId: number | undefined;
    accountId: number;
    archivedTransactions: boolean;
}

export const CancelTransactionModal = (props: CancelTransactionModalProps) => {
    const { t } = usePhrase();
    const [isCancellingTransaction, setIsCancellingTransaction] = useState(false);

    const handleCancelTransactionButtonClicked = async () => {
        if (!props.transactionId) return props.handleClose();
        setIsCancellingTransaction(true);
        await walletService.cancelPayment(props.transactionId);
        await mutate(`${API_URL}`);
        await mutate([`${API_URL}/transactions`, props.accountId, props.archivedTransactions]);
        setIsCancellingTransaction(false);
        props.handleClose();
    };

    return (
        <ConfirmDialog
            title={''}
            open={props.isOpen}
            handleClose={props.handleClose}
            actionText={t(WALLET_REQUEST_PHRASES.CANCEL_BUTTON)}
            actionHandlerSubmitting={isCancellingTransaction}
            cancelText={t(WALLET_PHRASES.CLOSE)}
            actionHandler={handleCancelTransactionButtonClicked}
            data-testid="CancelTransactionModal"
        >
            <span style={{ display: 'block' }}>
                {t(WALLET_PHRASES.CANCEL_TRANSACTION_ARE_YOU_SURE)}
            </span>
        </ConfirmDialog>
    );
};
